import { GlobalResponseObject } from "../../common";
import { QuestionReqModel } from "./question-req-model";

export class QuestionReqResponse extends GlobalResponseObject {
    data: QuestionReqModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data: QuestionReqModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}